import type { FC } from 'react';
import Content from '../Content';
import { ImageProperties } from '../../../../../../core/domain/map';

type Props = {
    properties: ImageProperties | null;
};

const ImagePopupOnHover: FC<Props> = ({ properties }) => {
    if (!properties) {
        return null;
    }

    return <Content properties={properties} />;
};

export default ImagePopupOnHover;
